import axios from 'axios';
import { APIResponse, Location, PaymentPlan } from '@arema/components/Classes';
import { DateData, OrderData } from './CheckoutClasses';
import { t } from 'i18next';
const ROOT_URL = process.env.REACT_APP_API_URL
const SEARCH_URL = process.env.REACT_APP_SEARCH_URL;
const DEBUG = process.env.REACT_APP_DEBUG=='1';

interface PostOptions{
	domain?: string,
	root_endpoint?: string
}

var CACHE : { [x: string]: APIResponse<any> } = {};

async function post<T=any>(endpoint: string, data?: any, opts?: PostOptions) : Promise<APIResponse<T>>{
	var options = {
		headers: {
			'show-code': DEBUG ? 1 : 0,
			'Content-Type': 'application/json'
		}
	}
	if(data instanceof FormData){
		options.headers['Content-Type'] = 'multipart/form-data';
	}

	try{
		var ENDPOINT = `${opts?.domain || ROOT_URL}/${(typeof opts?.root_endpoint !== 'undefined') ? opts.root_endpoint : 'checkout/'}${endpoint}`;
		if(DEBUG) console.log("POST "+ENDPOINT);
		var res = await axios.post(ENDPOINT, data, options);
		if(DEBUG) console.log(` => Response: ${(res.headers['content-length']/1024).toFixed(2)} KB`);
		return res.data as APIResponse<T>;
	}catch(err){
		if(DEBUG) console.error(err);
		return {
			error: true, 
			message: 'Hubo un error inesperado (API-LCL-1)',
			code: 'API-LCL-1',
		}
	}
};

var cachePost = async <T>(endpoint: string, key: string, data: any, opts?: PostOptions) : Promise<APIResponse<T>>=>{
	if(CACHE[key]) return CACHE[key] as APIResponse<T>;
	var res = await post(endpoint, data, opts);
	if(!res.error) CACHE[key] = res;
	return res;
}

var getDate = (date_id: number, queue_token: string=null, access_token: string=null)=>{
	return post<DateData>('date', { date_id, queue_token, access_token });
}

var createOrder = (cart: { price_id: number, seat_id: number, quantity: number }[], delivery_id: number, captcha?: string, queue_token?: string)=>{
	return post('order/create', {
		cart, delivery_id, captcha, queue_token
	});
}

var getOrder = (token: string)=>{
	return post<OrderData>('order/get', {
		token
	})
}

var sendForm = (token: string, form: FormData)=>{
	form.append('token', token);
	return post('order/form/edit', form);
}

interface CheckoutData{
	first_name: string,
	last_name: string,
	email: string,
	zipcode: string,
	phone: string,
	payment_plan?: number,
	payment_method: number,
	card_token?: string,
	device_fingerprint?: string,
	location?: Location
}
var completeOrder = (token: string, data: CheckoutData)=>{
	return post<{
		finished: boolean,
		paid: boolean,
		redirect?: string,
		payment_method: number,
		payment_cost?: number, 
		tickets_url?: string,
		reference?: string,
		date_expiration?: number,
	}>('order/finish', {
		token,
		...data
	});
}

var getSeatmap = (date_id: number, section_id: number, queue_token?: string)=>{
	return post('seats', { date_id, section_id, queue_token });
}

var getAccessCode = async (event_id: number, code: string, captcha: string)=>{
	return post<{ token: string }>('events/access', { event_id, code, captcha }, {
		root_endpoint: 'public/'
	});
}

var getPaymentPlans = (events: number[])=>{
	return cachePost<PaymentPlan[]>('methods/plans', `PPEV-${events.join(',')}`, { events });
}

var getCouponToken = async (code: string, dates: number[])=>{
	var res = await cachePost<{
		found: boolean,
		token: string
	}>('coupons', `CPSH-${code.toUpperCase().trim()}`, {
		code,
		dates
	}, {
		root_endpoint: '',
		domain: SEARCH_URL
	});
	if(res.error){
		res.message = t('common.unexpected_code', { code: res.code });
		return res;
	}
	return res;
}

var applyCoupon = async (order_token: string, coupon_token: string)=>{
	return post<{
		// delivery_cost: number,
		valid: boolean,
		tickets: {
			ticket_hash: string,
			ticket_cost: number,
			commission: number,
			original_cost: number
			original_commission: number,
		}[]
	}>('order/coupon/apply', {
		order_token,
		coupon_token
	});
}

export default {
	DEBUG,
	applyCoupon,
	completeOrder,
	createOrder,
	getAccessCode,
	getCouponToken,
	getDate,
	getOrder,
	getPaymentPlans,
	getSeatmap,
	sendForm,
}